import * as Constants from '../Constant';

const initialState = {
    message: {},
    receptionistList: {},
}

export default function receptionistReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.POST_RECEPTIONIST:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_RECEPTIONIST:
            return {
                ...state,
                receptionistList: action.payload,
            }
        case Constants.UPDATE_RECEPTIONIST:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.DELETE_RECEPTIONIST:
            return {
                ...state,
                message: action.payload,
            }
        default:
            return state;
    }
}